import React from "react";
import Button from "components/form/Button";
import { FailedAgreementIcon } from "icons/action/FailedIcon";
import { useNavigate, useParams } from "react-router-dom";
import {
  decode,
  encode,
  customerFacingPaymentError,
} from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

interface AgreementFailedProps {
  failedReason?: string | null;
  handleUpdatePaymentMethod?: () => void;
}
const PaymentAgreementFailed = ({
  failedReason,
  handleUpdatePaymentMethod,
}: AgreementFailedProps) => {
  const navigate = useNavigate();
  const { id: actionId } = useParams();
  const testAttrs = useTestAttrsFactory();
  const clusterId = decode(actionId || "")?.split("_")[1];
  let cluster_id = encode(`${clusterId}`, "ci_");

  return (
    <div
      className="h-full m-auto flex flex-col justify-center items-center gap-10 w-full max-w-[630px] p-5"
      {...testAttrs("payment-agreement-failed", "Payment agreement failed")}
    >
      <FailedAgreementIcon aria-hidden="true" />
      <p className="lg:text-2xl text-xl font-medium text-txtPrimary">
        Payment agreement failed
      </p>

      <div className="w-full text-center">
        <p className="w-full px-2 py-5 bg-bgThird lg:text-xl text-lg text-txtParagraph rounded-md">
          {customerFacingPaymentError(failedReason) || "Payment Failed"}
        </p>
      </div>

      <div className="text-center">
        <p className="lg:text-xl text-txtParagraph rounded-md">
          Sorry! Your payment method was declined.
        </p>
      </div>

      <div className="text-center">
        <Button
          text={"Update payment method"}
          className="w-full"
          {...testAttrs("update-payment-method", "Update payment method")}
          onClick={handleUpdatePaymentMethod}
        />
        <p
          className="mt-6  lg:text-base text-sm text-btnPrimaryActive cursor-pointer hover:!text-btnPrimaryHover "
          role="button"
          tabIndex={0}
          {...testAttrs("back-to-dashboard", "Back to dashboard")}
          onClick={() => navigate(`/${cluster_id}/dashboard`)}
        >
          Back to dashboard
        </p>
      </div>
    </div>
  );
};

export default PaymentAgreementFailed;
